import { render, staticRenderFns } from "./VaSliderColorPicker.demo.vue?vue&type=template&id=507909cc&"
import script from "./VaSliderColorPicker.demo.vue?vue&type=script&lang=js&"
export * from "./VaSliderColorPicker.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports